import _Clear from "@material-ui/icons/esm/Clear";
import React from 'react';
import classnames from 'classnames';
import classes from './mobile-header.scss';
const MobileHeader = ({
  className = undefined,
  headerText,
  onClose
}) => /*#__PURE__*/React.createElement("div", {
  className: classnames(className, classes.container)
}, headerText, /*#__PURE__*/React.createElement(_Clear, {
  className: classes.closeIcon,
  onClick: onClose
}));
export default MobileHeader;